// better-auth client for the hq console. Talks to the hq worker at /api/auth.
// No sign-up surface — admins are seeded server-side.

import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  baseURL: typeof window === "undefined" ? "" : window.location.origin,
});

export const { signIn, signOut, useSession } = authClient;
